import { render, staticRenderFns } from "./ImagePickerDialog.vue?vue&type=template&id=5bdfbde2&scoped=true&"
import script from "./ImagePickerDialog.vue?vue&type=script&lang=js&"
export * from "./ImagePickerDialog.vue?vue&type=script&lang=js&"
import style0 from "./ImagePickerDialog.vue?vue&type=style&index=0&id=5bdfbde2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdfbde2",
  null
  
)

export default component.exports